import {
  useInteractionHistoricQuery,
  useShopHistoricQuery,
} from "@/query/historicQuery"
import { History } from "lucide-react"
import { Button } from "../ui/button"

export const HistoricHeader = () => {
  const { refetchShopHistoric } = useShopHistoricQuery()
  const { refetchInteractionHistoric } = useInteractionHistoricQuery()
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
          <History className="h-6 w-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Historique
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Suivi des modifications de votre boutique
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          onClick={() => {
            refetchShopHistoric()
            refetchInteractionHistoric()
          }}
          variant="outline"
          size="sm"
          className="flex items-center gap-2"
        >
          <History className="h-4 w-4" />
          Actualiser
        </Button>
      </div>
    </div>
  )
}
